import http from "../../utils/http"

/**
 * 获取首页订单通告
 */
export function apiOrderNotice() {
    return http({
        url: "/api/order/notice"
    })
}
